(() => {
  const STORAGE_PREFIX = 'ootb:collection-scroll:';
  const TTL = 1000 * 60 * 60 * 6; // 6 Stunden
  let clickedProductId = '';
  let restoreStarted = false;

  const isCollectionListing = () => {
    return (
      window.location.pathname.includes('/collections/') &&
      !window.location.pathname.includes('/products/')
    );
  };

  const getStorageKey = () => {
    const url = new URL(window.location.href);
    url.hash = '';
    return STORAGE_PREFIX + url.pathname + url.search;
  };

  const saveScrollState = (productId = '') => {
    if (!isCollectionListing()) return;

    const key = getStorageKey();

    const state = {
      y: Math.round(window.scrollY || window.pageYOffset || 0),
      productId: productId || '',
      ts: Date.now()
    };

    try {
      sessionStorage.setItem(key, JSON.stringify(state));

      const oldHistoryState =
        history.state && typeof history.state === 'object' ? history.state : {};

      history.replaceState(
        {
          ...oldHistoryState,
          ootbCollectionScrollKey: key
        },
        '',
        window.location.href
      );
    } catch (e) {
      // sessionStorage/history kann in seltenen Privacy-Modi blockiert sein
    }
  };

  const getSavedScrollState = () => {
    try {
      const key =
        history.state &&
        typeof history.state === 'object' &&
        history.state.ootbCollectionScrollKey;

      if (!key) return null;

      const raw = sessionStorage.getItem(key);
      if (!raw) return null;

      const state = JSON.parse(raw);

      if (!state || Date.now() - state.ts > TTL) {
        sessionStorage.removeItem(key);
        return null;
      }

      return state;
    } catch (e) {
      return null;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isCollectionListing()) return;

      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;

      const card = link.closest('[data-product-card-id]');
      clickedProductId = card ? card.getAttribute('data-product-card-id') : '';

      saveScrollState(clickedProductId);
    },
    true
  );

  window.addEventListener(
    'pagehide',
    () => {
      if (!clickedProductId) return;
      saveScrollState(clickedProductId);
    },
    true
  );

  const restoreScroll = () => {
    if (!isCollectionListing()) return;
    if (restoreStarted) return;

    const savedState = getSavedScrollState();
    if (!savedState) return;

    restoreStarted = true;

    const targetY = Number(savedState.y) || 0;
    const targetProductId = savedState.productId || '';
    let attempts = 0;
    const maxAttempts = 140;

    const tick = () => {
      attempts += 1;

      if (targetProductId) {
        const targetCard = document.querySelector(
          `[data-product-card-id="${targetProductId}"]`
        );

        if (targetCard) {
          targetCard.scrollIntoView({
            block: 'center'
          });
          return;
        }
      }

      const pageHeight = Math.max(
        document.body ? document.body.scrollHeight : 0,
        document.documentElement.scrollHeight
      );

      const enoughPageHeight = pageHeight >= targetY + window.innerHeight;

      if (enoughPageHeight || attempts >= maxAttempts) {
        window.scrollTo(0, targetY);

        // Korrektur, falls Bilder/Produkte kurz danach noch Layout verschieben
        setTimeout(() => window.scrollTo(0, targetY), 250);
        setTimeout(() => window.scrollTo(0, targetY), 900);

        return;
      }

      // Endless Scroll triggern, bis die alte Höhe / alte Produktkarte wieder da ist
      window.scrollTo(0, pageHeight);
      window.dispatchEvent(new Event('scroll'));

      setTimeout(tick, 150);
    };

    setTimeout(tick, 150);
  };

  window.addEventListener('pageshow', (event) => {
    // Wenn der Browser die Seite aus dem Back-Forward-Cache holt,
    // ist Scrollposition + DOM meistens sowieso noch exakt erhalten.
    if (event.persisted) return;

    restoreScroll();
  });

  document.addEventListener('DOMContentLoaded', restoreScroll);
})();